// API Configuration - Uses current origin for production, env variable for localhost
export const API_URL = window.location.hostname === 'localhost' 
  ? process.env.REACT_APP_BACKEND_URL 
  : window.location.origin;
